import { DeletedOption } from 'pages/AutomationEngine/types';
import { VariableUpdateStep } from '../actionSectionTypes';

// note also used by File Extraction as the object models match
export const updateVariableRemoveVariable = (
  step: VariableUpdateStep,
  variableName: string,
  errorIds: string[]
) => {
  const nextErrorIds: string[] = [];
  const nextStep = { ...step };

  if (step.details?.chosenVariable?.label === variableName) {
    const { chosenVariable } = step.details;
    if (!nextErrorIds.includes(step.id)) {
      nextErrorIds.push(step.id);
    }
    nextStep.hasError = true;
    nextStep.details = {
      ...nextStep.details,
      chosenVariable: { ...chosenVariable, deleted: true },
    };
  }

  const nextSources = nextStep.details.sources.map((source) => {
    if (
      source?.sourceType === 'variable' &&
      source?.automationVariable?.name === variableName
    ) {
      if (!nextErrorIds.includes(step.id)) {
        nextErrorIds.push(step.id);
      }

      nextStep.hasError = true;

      return {
        ...source,
        automationVariable: {
          ...source?.automationVariable,
          value: {
            ...(source?.automationVariable?.value as DeletedOption),
            deleted: true,
          },
        },
        hasError: true,
        error: { hasError: true },
      };
    }

    return source;
  });

  return {
    nextStep: {
      ...nextStep,
      details: { ...nextStep.details, sources: nextSources },
    },
    nextErrorIds,
  };
};
